/**
 * Restroom Resources — main.js
 * Plain vanilla JS only. All content is in HTML; JS adds interactivity only.
 */

// Table D-1 fixture counts only. The 2006-05-17 OSHA interpretation explicitly
// uses one toilet for 20 employees despite the table's overlapping row labels.
function calculateJobSiteFixtures(value) {
  if (!/^\d+$/.test(String(value))) return null;
  var workers = Number(value);
  if (!Number.isSafeInteger(workers) || workers < 1) return null;
  if (workers <= 20) return { toilets: 1, urinals: null, perWorkers: null };
  var perWorkers = workers < 200 ? 40 : 50;
  var fixtures = Math.ceil(workers / perWorkers);
  return { toilets: fixtures, urinals: fixtures, perWorkers: perWorkers };
}

document.addEventListener('DOMContentLoaded', function () {
  var pagePath = window.location.pathname.replace(/\/+$/, '');
  var isResourcePage = pagePath === '/resources' || pagePath.startsWith('/resources/');
  if (isResourcePage && document.querySelector('.resource-aid')) {
    var resourceScript = document.createElement('script');
    resourceScript.src = '/resources.js?v=1';
    document.head.appendChild(resourceScript);
  }

  // Load location/map behavior only on pages that actually contain a map.
  if (document.getElementById('locations-map')) {
    var locationsScript = document.createElement('script');
    locationsScript.src = '/locations.js?v=2b4e0f428b35';
    document.head.appendChild(locationsScript);
  }

  // ── Hamburger / mobile nav ─────────────────────────────────────────────
  var hamburger = document.getElementById('hamburger');
  var mobileNav = document.getElementById('mobile-nav');
  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', function () {
      var isOpen = mobileNav.classList.toggle('open');
      hamburger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });
    // Services accordion in mobile nav
    mobileNav.querySelectorAll('.mobile-nav-accordion-trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var panel = trigger.nextElementSibling;
        var isOpen = panel.classList.toggle('open');
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
    // Close mobile nav when a link is clicked
    mobileNav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        mobileNav.classList.remove('open');
        hamburger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });
    });
  }

  // ── Calculator mode tabs (aria-controls based) ─────────────────────────
  var calcTabs   = document.querySelectorAll('.calc-tab');
  var calcPanels = document.querySelectorAll('.calc-panel');

  function activateCalcTab(btn) {
    calcTabs.forEach(function (t) {
      var active = t === btn;
      t.classList.toggle('active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
      t.setAttribute('tabindex', active ? '0' : '-1');
    });
    var targetId = btn.getAttribute('aria-controls');
    calcPanels.forEach(function (panel) {
      var active = panel.id === targetId;
      panel.classList.toggle('active', active);
      if (active) panel.removeAttribute('hidden');
      else panel.setAttribute('hidden', '');
    });
  }

  calcTabs.forEach(function (tab) {
    tab.addEventListener('click', function () { activateCalcTab(tab); });
    tab.addEventListener('keydown', function (event) {
      var index = Array.from(calcTabs).indexOf(tab);
      var next;
      if (event.key === 'ArrowRight') next = (index + 1) % calcTabs.length;
      else if (event.key === 'ArrowLeft') next = (index + calcTabs.length - 1) % calcTabs.length;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = calcTabs.length - 1;
      else return;
      event.preventDefault();
      activateCalcTab(calcTabs[next]);
      calcTabs[next].focus();
    });
  });

  // ── Construction-site minimum fixtures (no duration multiplier) ──────
  var jobsiteWorkers = document.getElementById('jobsite-workers');
  var jobsiteSlider = document.getElementById('jobsite-workers-slider');
  var jobsiteWorkersVal = document.getElementById('jobsite-workers-val');
  var jobsiteToilets = document.getElementById('jobsite-toilets');
  var jobsiteUrinals = document.getElementById('jobsite-urinals');
  var jobsiteToiletLabel = document.getElementById('jobsite-toilet-label');
  var jobsiteRule = document.getElementById('jobsite-rule');
  var jobsiteError = document.getElementById('jobsite-error');

  function updateJobsiteCalc() {
    if (!jobsiteWorkers) return;
    var result = calculateJobSiteFixtures(jobsiteWorkers.value);
    jobsiteWorkersVal.textContent = result ? Number(jobsiteWorkers.value).toLocaleString() : '—';
    if (result) {
      // Keep the slider usable for larger counts entered manually, without
      // clamping the exact input or losing single-worker keyboard increments.
      jobsiteSlider.max = String(Math.max(1000, Number(jobsiteWorkers.value)));
      jobsiteSlider.value = jobsiteWorkers.value;
    }
    jobsiteWorkers.setAttribute('aria-invalid', result ? 'false' : 'true');
    jobsiteWorkers.setCustomValidity(result ? '' : 'Enter a positive whole-number worker count within the supported range.');
    jobsiteError.hidden = !!result;
    jobsiteToilets.textContent = result ? result.toilets.toLocaleString() : '—';
    jobsiteUrinals.textContent = result && result.urinals !== null ? result.urinals.toLocaleString() : '—';
    jobsiteToiletLabel.textContent = result && result.perWorkers === null ? 'Toilet facility' : 'Toilet seats';
    if (!result) {
      jobsiteRule.textContent = 'Enter a valid whole-number worker count to see minimum fixtures.';
    } else if (result.perWorkers === null) {
      jobsiteRule.textContent = 'Up to 20 workers; no separate urinal minimum.';
    } else {
      jobsiteRule.textContent = Number(jobsiteWorkers.value).toLocaleString() + ' workers · 1 toilet seat + 1 urinal per ' + result.perWorkers + ' workers.';
    }
  }

  if (jobsiteWorkers) jobsiteWorkers.addEventListener('input', updateJobsiteCalc);
  if (jobsiteSlider) jobsiteSlider.addEventListener('input', function () {
    jobsiteWorkers.value = jobsiteSlider.value;
    updateJobsiteCalc();
  });
  updateJobsiteCalc();

  // ── Private-event trailer estimator (sliders, live update) ─────────────
  var constWorkers    = document.getElementById('const-workers');
  var constShift      = document.getElementById('const-shift');
  var constWorkersVal = document.getElementById('const-workers-val');
  var constShiftVal   = document.getElementById('const-shift-val');
  var constResult     = document.getElementById('const-result');

  function calcPrivateEventTrailers() {
    var guests = parseInt(constWorkers.value, 10) || 0;
    var hours   = parseFloat(constShift.value) || 8;
    // One premium trailer supports about 150 guests for a six-hour private event.
    return Math.max(1, Math.ceil((guests / 150) * (hours / 6)));
  }

  function updateConstCalc() {
    if (!constWorkers || !constShift) return;
    constWorkersVal.textContent = parseInt(constWorkers.value, 10).toLocaleString();
    constShiftVal.textContent   = constShift.value;
    if (constResult) constResult.textContent = calcPrivateEventTrailers();
  }

  if (constWorkers) constWorkers.addEventListener('input', updateConstCalc);
  if (constShift)   constShift.addEventListener('input', updateConstCalc);
  updateConstCalc();

});
